import React, {useEffect, useState} from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartEvent,
  LegendItem,
  LegendElement,
  Chart,
  LineElement,
  CategoryScale, LinearScale, BarElement, Title, PointElement, type ChartOptions
} from 'chart.js';
import {Bar, Line, Pie} from 'react-chartjs-2';
import {ChartType} from "chart.js/dist/types";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import {ClipLoader} from "react-spinners";
import {apiConfig} from "../../../../../../config";
import axios from "axios";

ChartJS.register(
  ArcElement,
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const LineOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
};


const dataLeads = {"labels" : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], "data" : [0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 27, 30, 27, 23, 26, 23, 26, 18, 15, 0, 0, 0, 0, 0]}

const LeadsStatByHours = (props: any) => {
  const [leadsData, setLeadsData]: [any, any] = useState(null)
  const [selectOperator, setSelectOperator]: [any, any] = useState(null)
  const [selectProject, setSelectProject]: [any, any] = useState(null)
  const [selectProjectsAll, setSelectProjectsAll]: [any, any] = useState([])
  const [selectOperatorsAll, setSelectOperatorsAll]: [any, any] = useState([])

  const [isLoading, setIsLoading] = useState(false)

  const monthDate: any = (new Date())
  monthDate.setMonth(monthDate.getMonth() - 1);
  const [startDate, setStartDate]: [any, any] = useState(monthDate.setHours(0, 0, 0));

  const currentDate: any = (new Date())
  currentDate.setDate(currentDate.getDate() + 1);
  const [endDate, setEndDate]: [any, any] = useState(currentDate.setHours(0,0,0));

  const LeadsData = async () => {
    setIsLoading(true)

    let data1: any = []

    let response_users = props.usersData
    let operatorsOptions = [
      {value: null, label: "Без оператора"}
    ]

    for (let i = 0; i < response_users.length; i++) {
      operatorsOptions.push(
        {value: response_users[i].id, label: response_users[i].name}
      )
    }
    setSelectOperatorsAll(operatorsOptions)

    let response_projects = props.projectsData
    let projectsOptions = [
      {value: null, label: "Без проекта"}
    ]

    for (let i = 0; i < response_projects.length; i++) {
      projectsOptions.push(
        {value: response_projects[i].id, label: response_projects[i].name}
      )
    }
    setSelectProjectsAll(projectsOptions)

    let tzoffset = (new Date()).getTimezoneOffset() * 60000;

    let startDateNormal = startDate ? (new Date(startDate - tzoffset)).toISOString() : null
    let endDateNormal = endDate ? (new Date(endDate - tzoffset)).toISOString() : null

    console.log(startDateNormal, endDateNormal)

    const config = {
      method: 'get',
      url: `${apiConfig.url}/statistic/dashboard/leads_by_hours`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      },
      params: {
        user_id: selectOperator ? selectOperator.value : null,
        project_id : selectProject ? selectProject.value : null,
        date_from: startDateNormal,
        date_to: endDateNormal,
      }
    };
    try {
      const response = await axios(config);

      console.log('HOURS RESPONSE', response.data)

      for (let i = 0; i < response.data.data.length; i++) {

        data1.push(response.data.data[i])
      }

      setLeadsData(
        {
          labels: response.data.labels,
          datasets: [
            {
              type: 'line' as const,
              label: `Line`,
              data: data1,
              stack: 'Stack 0',
              backgroundColor: '#157115',
              borderColor: '#157115',
              pointRadius: 2,
              pointHoverRadius: 4,
            },
            {
              type: 'bar' as const,
              label: `Bar`,
              data: data1,
              stack: 'Stack 1',
              backgroundColor: '#00ff00',
              borderColor: '#00ff00',
              pointRadius: 5,
              pointHoverRadius: 7,
            },
          ]
        }
      );

      setIsLoading(false)


    } catch (error) {
      console.error('error', error);
    }
  }


  useEffect(() => {
    LeadsData()
  }, [])

  return (
    <div style={{display: 'flex', flex: 1, flexDirection: 'column'}}>
      <div style={{display: "flex", flexDirection: "row", paddingTop: 20, paddingBottom: 20, alignItems: "center"}}>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: 20}}>
          <div style={{marginRight: 10}}>
            Оператор:
          </div>
          <Select
            onChange={(item) => {
              setSelectOperator(item)
            }}
            options={selectOperatorsAll}
          />
        </div>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: 20}}>
          <div style={{marginRight: 10}}>
            Проект:
          </div>
          <Select
            onChange={(item) => {
              setSelectProject(item)
            }}
            options={selectProjectsAll}
          />
        </div>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
          <div>
            Дата от:
          </div>

          <div style={{display: "flex", marginRight: 20, marginLeft: 10}}>
            <DateTimePicker
              onChange={(date: any) => {
                date ? setStartDate(new Date(date)) : setStartDate(null)
              }}
              value={startDate}
              disableClock={true}
            />
          </div>
          <div>
            Дата до:
          </div>
          <div style={{display: "flex", marginLeft: 10}}>
            <DateTimePicker
              onChange={(date: any) => {
                date ? setEndDate(new Date(date)) : setEndDate(null)
              }}
              value={endDate}
              disableClock={true}
            />
          </div>
        </div>
        <button
          onClick={() => {
            LeadsData()
          }}
          style={{
            display: "flex",
            height: 40,
            borderRadius: 5,
            justifyContent: "center",
            alignItems: 'center',
            borderWidth: 1,
            borderColor: "black",
            marginLeft: 60
          }}>
          Применить фильтр
        </button>
      </div>
      {!isLoading && leadsData && <Bar title={"Лиды по часам"} options={LineOptions} data={leadsData}/>}
      {isLoading && <div style={{
        fontSize: 30,
        minHeight: 700,
        width: "100%",
        height: "100%",
        // backgroundColor: "rgba(100, 100, 100, 0.2)",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: 'center',
      }}>
          <ClipLoader size={150} color={"black"}/>
      </div>}
    </div>
  )
}

export default LeadsStatByHours
